import React, { createContext, useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { StickyMobileCta } from "@/components/Floating";
import CookieConsent from "@/components/CookieConsent";
import WhatsAppButton from "@/components/WhatsAppButton";
import { useFetch } from "@/lib/useData";

const SiteCtx = createContext(null);
export const useSite = () => useContext(SiteCtx);

// One-time cleanup: when React mounts, remove the static SEO tags injected
// in index.html so React Helmet becomes the single source of truth at runtime.
// Crawlers without JS still receive the index.html defaults (homepage SEO).
let staticTagsStripped = false;
function stripStaticSeoTags() {
  if (staticTagsStripped || typeof document === "undefined") return;
  const selectors = [
    'link[rel="canonical"]:not([data-rh])',
    'meta[property^="og:"]:not([data-rh])',
    'meta[name^="twitter:"]:not([data-rh])',
    'meta[name="description"]:not([data-rh])',
  ];
  selectors.forEach((sel) => {
    document.head.querySelectorAll(sel).forEach((n) => n.remove());
  });
  staticTagsStripped = true;
}

export default function Layout() {
  const { data: settings } = useFetch("/site-settings");
  const location = useLocation();

  useEffect(() => {
    stripStaticSeoTags();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <SiteCtx.Provider value={settings}>
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-navy focus:text-white focus:rounded-lg focus:shadow-card">
        Skip to main content
      </a>
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <main id="main" className="flex-1">
          <Outlet />
        </main>
        <Footer settings={settings} />
        <StickyMobileCta />
        <WhatsAppButton />
        <CookieConsent />
      </div>
    </SiteCtx.Provider>
  );
}
